import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/AlertDialog";
import Link from "next/link";
import { useTranslation } from "react-i18next";

const ActivateAccountAlert = () => {
  const { t } = useTranslation("register");

  return (
    <AlertDialog open={true}>
      <AlertDialogContent className="z-[55]">
        <AlertDialogHeader>
          <AlertDialogTitle>{t("account_activation")}</AlertDialogTitle>
          <AlertDialogDescription className="leading-relaxed">
            {t("account_activation_text")}
            <br />
            {t("account_activation_text_check_spam")}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Link href="/login" passHref>
            <AlertDialogAction>{t("ok_button")}</AlertDialogAction>
          </Link>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default ActivateAccountAlert;
